import './Subiecte.css';

export default function Subiecte2018() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2018{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectAugust2018MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2018/SubiectAugust2018MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremAugust2018MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectAugust2018SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremAugust2018SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectIunie2018MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2018/SubiectIunie2018MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremIunie2018MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectIunie2018SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2018/SubiectIunie2018SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremIunie2018SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii (Rezervă):</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectRezerva2018SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremRezerva2018SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectSpeciala2018MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremSpeciala2018MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectSimulare2018MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2018/SubiectSimulare2018MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremSimulare2018MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectSimulare2018SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2018/SubiectSimulare2018SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremSimulare2018SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectModel2018MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2018/SubiectModel2018MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremModel2018MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2018/SubiectModel2018SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2018/SubiectModel2018SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2018/BaremModel2018SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}